import { useForm } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { sendResetRequest } from '../../slices/auth.slice';
import { RootState } from '../../store';
import { useAppDispatch } from '../../store/hooks';
import { ForgotPasswordI } from '../../utils/interface';
import ForgotPasswordWrapper from './ForgotPassword';

const ForgotPassword = () => {
  const dispatch = useAppDispatch();
  const { loading } = useSelector((state: RootState) => state.auth);

  const { control, handleSubmit } = useForm<ForgotPasswordI>({
    mode: 'all',
    defaultValues: {
      customerCode: '',
      email: '',
    },
  });

  const onSubmit = (data: ForgotPasswordI) => {
    dispatch(sendResetRequest(data));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <ForgotPasswordWrapper control={control} logoUrl={''} isApiLoading={loading} />
    </form>
  );
};

export default ForgotPassword;
